import React from 'react'
import { Container, Col, Row, ListGroup, Nav } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faMailBulk } from '@fortawesome/free-solid-svg-icons/faMailBulk'
import { faLocation } from '@fortawesome/free-solid-svg-icons/faLocation'
import { SocialIcon } from 'react-social-icons'

import { Link } from 'react-router-dom'
import WhyChooseUs from '../WhyChooseUs/WhyChooseUs'
import RateSite from './RateSite'
import './Footer.css'

const ADDRESS = '7701 Sudley Road , Manassas, VA 20109'
const PHONE = '703-936-3026'
const EMAIL = 'Akuanderson@gmail.com'
const BOOK_APPOINTMENT_URL = 'https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm'

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <WhyChooseUs />
        <div className="footer-book-cta">
          <Container>
            <a
              href={BOOK_APPOINTMENT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-book-cta-btn"
            >
              Book an appointment
            </a>
          </Container>
        </div>
        <Container fluid className="footer-main">
          <Row className="footer-grid">
            <Col xs={12} md={6} lg={3} className="footer-col">
              <h3 className="footer-heading">Quick links</h3>
              <Nav className="footer-nav flex-column">
                <Nav.Link as={Link} to="/about" className="footer-link">About</Nav.Link>
                <Nav.Link as={Link} to="/contact" className="footer-link">Contact us</Nav.Link>
                <Nav.Link as={Link} to="/faq" className="footer-link">FAQ</Nav.Link>
                <Nav.Link as={Link} to="/appointment" className="footer-link">Appointment</Nav.Link>
                <Nav.Link as={Link} to="/location" className="footer-link">Location</Nav.Link>
              </Nav>
            </Col>
            <Col xs={12} md={6} lg={3} className="footer-col">
              <h3 className="footer-heading">Visit us</h3>
              <ListGroup variant="flush" className="footer-list">
                <ListGroup.Item className="footer-list-item">
                  <FontAwesomeIcon icon={faLocation} className="footer-icon" />
                  <span>{ADDRESS}</span>
                </ListGroup.Item>
                <ListGroup.Item className="footer-list-item">
                  <FontAwesomeIcon icon={faPhone} className="footer-icon" />
                  <a href={`tel:${PHONE}`}>{PHONE}</a>
                </ListGroup.Item>
                <ListGroup.Item className="footer-list-item">
                  <FontAwesomeIcon icon={faMailBulk} className="footer-icon" />
                  <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col xs={12} md={6} lg={3} className="footer-col">
              <h3 className="footer-heading">Opening hours</h3>
              <ListGroup variant="flush" className="footer-list">
                <ListGroup.Item className="footer-list-item">Mon–Sat: Open all day</ListGroup.Item>
                <ListGroup.Item className="footer-list-item">Sun: 6:00am – 6:00pm</ListGroup.Item>
              </ListGroup>
              <div className="footer-social">
                <SocialIcon url="https://www.facebook.com/sarahadombraiding" className="footer-social-icon" />
                <SocialIcon url="https://www.instagram.com/sarahadombraiding/" className="footer-social-icon" />
              </div>
              <a
                href="https://www.instagram.com/sarahadombraiding/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-follow-instagram"
              >
                Follow us on Instagram
              </a>
            </Col>
            <Col xs={12} md={6} lg={3} className="footer-col footer-col-facebook">
              <h3 className="footer-heading">Facebook</h3>
              <div className="footer-embed-wrap">
                <iframe
                  src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsarahadombraiding&tabs=timeline&width=340&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                  width="340"
                  height="200"
                  style={{ border: 'none', overflow: 'hidden' }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen
                  title="Facebook"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="footer-bottom">
          <Container>
            <Row className="footer-bottom-row">
              <Col xs={12} md={6} className="footer-copy">
                <p>© {new Date().getFullYear()} Sarah Adom Braiding Salon</p>
              </Col>
              <Col xs={12} md={6} className="footer-credit">
                <p>Developed by Nass Tech — Need service? Call 571-390-4273 or visit  <a href="https://kwekuanaisie.com" target="_blank" rel="noopener noreferrer">kwekuanaisie.com</a></p>
              </Col>
            </Row>
            <Row className="footer-payment-row">
              <Col xs={12}>
                <p className="footer-payment-text">Payment accepted: Cash, Visa, Mastercard, Cash App, Credit Card, Venmo, Zelle</p>
              </Col>
            </Row>
            <Row className="footer-rate-row">
              <Col xs={12}>
                <RateSite />
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    </>
  )
}

export default Footer
